// extracted by mini-css-extract-plugin
export default {"highlight":"highlight_highlight__r6V45"};